<template>
  <WsUpdate
    :modelName="modelName"
    :modelVersionName="modelVersionName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    titleKey="last_version.name"
    editType="updateVersion"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/audit_template";
export default {
  data: () => ({
    modelName: model.modelName,
    modelVersionName: model.modelVersionName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: [
                "locales",
              ],
            },
          ],
        },
      ],
    },
  }),
};
</script>